import React, { useEffect, useState } from "react";
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";
import api from "../../api";

export default function StatsGraph() {
  const [data, setData] = useState([]);

  useEffect(() => {
    api.get("/admin/graph-data")
      .then(res => setData(res.data))
      .catch(err => console.error("Error loading chart data:", err));
  }, []);

  return (
    <div className="graph-card">
      <h3 className="graph-title">Attendance Trend</h3>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={data}>
          <CartesianGrid stroke="#ccc" />
          <XAxis dataKey="date" />
          <YAxis allowDecimals={false} />
          <Tooltip />
          <Line type="monotone" dataKey="attended" stroke="#4F46E5" strokeWidth={2} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
